
(function MemberShipEvent() {
  async function logoutAjax() {
    try {
      const res = await fetch(`/account/logout`, {
        method: 'GET',
        headers: {
          'cache-control': 'max-age=0'
        }
      });
    } catch (err) {
    } finally {
      // 清空登陆状态
      window.customer = null
      window.member_is_login = false;
      await clearGuestMemberRewards();
      await refreshThemeCart();
    }
  }

  async function fetchUserPoints() {
    const res = await window.ogl_fetch.get(
      '/api/v1/customer-center/get-customer-points-list-paging',
      {
        customer_id: window.customer.id,
        current_page: 1,
        page_size: 1000
      }
    );
    const available_points = res.data?.total_list?.[0]?.available_points || 0;
    window.customer.total_points = available_points;
    return window.customer;
  }

  async function getPointsUpdateCouponEnable(option_doms) {
    try {
      const member_points_dom = document.querySelector(
        '#logined #member-points'
      );
      const selectSelected = document.querySelector('#select-selected .select-selected');
      const couponSelector = document.querySelector('.coupon-selector_wrapper .coupon-selector');
      const cusomter = await fetchUserPoints();
      member_points_dom &&
        (member_points_dom.innerText = cusomter.total_points);
      Shopify.analytics.publish("member-datac", {
        name: "point_report",
        customerId: window.customer_id || "",
        platform: !window.innerWidth < 768 ? "pc" : "mobile",
        point_value: cusomter.total_points
      });
      option_doms.forEach((option, index) => {
        const enable_option = Number(option.dataset.points) <= cusomter.total_points
        // 这里其实可以提早跳出循环，算了option不多
        if (index == 0 && !enable_option) {
          selectSelected.innerText = 'Unlock discount with 100 points'
          couponSelector.classList.add('disabled')
        }
        if (enable_option) {
          option.removeAttribute('data-disabled')
        }
      })
      return true
    } catch (err) {
      // 获取失败，登出刷新购物车
      return false
    }
  }

  /**
    请求后端积分兑换券code
    @params {
      redeem_type: 积分兑换券类型 
    }
  */
  async function redeemCoupon(redeem_type) {
    return await window.ogl_fetch.post(
      '/api/v1/customer-center/redeem-discount-code',
      {
        customer_id: window.customer.id,
        redeem_type: redeem_type,
        num: 1
      }
    );
  }

  /**
    请求后端积分兑换券code
    @params {
      coupon_code: 积分回退
    }
  */
  async function recallCoupon(coupon_code) {
    return await window.ogl_fetch.post(
      '/api/v1/customer-center/batch-recall-shopify-customer-discount-code',
      {
        shopify_discount_code_list: [coupon_code],
      }
    );
  }

  async function updateCoupon(coupon_code) {
    try {
      let formData = {
        discount: coupon_code
      };
      const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then((res) => res.json());
      // 更新cart信息，为了拿到当前在用券
      window.mibaoCartData = res
      const applicable = res?.discount_codes[0]?.applicable;
      if (res?.discount_codes[0] && !applicable) {
        window.oglToast.show({ message: `Sorry, Points couldn't be used with your existing discounts.` });
      }
    } catch (err) { }
  }

  window.handleRemoveCoupon = async function handleRemoveCoupon(current_code) {
    try {
      window.oglLoading(true)
      Shopify.analytics.publish("member-datac", {
        customerId: window.customer_id || "",
        platform: !window.innerWidth < 768 ? "pc" : "mobile",
        discount_code: current_code,
        name: 'remove_coupon',
      });
      const rest_code_list = window.mibaoCartData.cart_level_discount_applications.map(item => item.title).filter(code => code !== current_code)
      const rest_codes = rest_code_list.join(',')
      // 一定要先回退再更新购物车
      await recallCoupon(current_code)
      await updateCoupon(rest_codes)
      await T4SThemeSP.Cart.getToFetch()
      window.oglLoading(false)
    } catch (err) {
      window.oglToast.show({ message: 'Remove Coupon Fail!' })
      window.oglLoading(false)
    }
  }

  async function applyCoupon(redeem_type) {
    try {
      const res = await redeemCoupon(redeem_type)
      window.mibaoCartData = await fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((res) => res.json());
      const coupon_code = `${res.data[0]?.discount_code},${window.mibaoCartData?.discount_codes?.map((item) => item.code).filter(code => code != res.data[0]?.discount_code).join(',')}`
      // 找不到折扣码终止请求
      if (!coupon_code) {
        throw ('no coupon_code return')
      }
      await updateCoupon(coupon_code);
      return true
    } catch (err) {
      window.oglToast.show({ message: 'Redeem Coupon Fail!' })
      return false
    } finally {
      await T4SThemeSP.Cart.getToFetch()
    }
  }

  const MEMBER_REWARDS_ATTRIBUTE = '_ogl_member_rewards';
  const MEMBER_SHIPPING_COUPON_YEAR = 2026;
  const MEMBER_SHIPPING_COUPON_MONTHS = { 1: 10, 2: 11, 3: 12 };
  const MEMBER_REWARD_OPTIONS = [
    { redeemType: '1', points: 100, amount: 5 },
    { redeemType: '2', points: 200, amount: 10 },
    { redeemType: '3', points: 300, amount: 15 },
    { redeemType: '4', points: 400, amount: 20 },
    { redeemType: '5', points: 500, amount: 25 },
    { redeemType: '6', points: 1000, amount: 50 }
  ].map((reward) => ({
    ...reward,
    label: `$${reward.amount} OFF / ${reward.points} Points`
  }));

  const memberRewardsState = {
    applied: { points: null, activity: null },
    cart: null,
    coupons: [],
    couponsLoaded: false,
    draft: { points: null, activity: null },
    initPromise: null,
    loading: false,
    points: 0
  };

  function getMemberRewardRoots() {
    return Array.from(document.querySelectorAll('[data-member-rewards-root]'));
  }

  function normalizeCode(code) {
    return String(code || '')
      .trim()
      .toLowerCase();
  }

  function uniqueCodes(codes) {
    const seen = new Set();
    return codes.filter((code) => {
      const normalized = normalizeCode(code);
      if (!normalized || seen.has(normalized)) return false;
      seen.add(normalized);
      return true;
    });
  }

  function getCartDiscountCodes(cart) {
    if (Array.isArray(cart?.discount_codes)) {
      return uniqueCodes(cart.discount_codes.map((item) => item?.code));
    }
    return uniqueCodes(
      (cart?.cart_level_discount_applications || []).map((item) => item?.title)
    );
  }

  function isCodeApplicable(cart, code) {
    const target = normalizeCode(code);
    if (!target) return false;
    const discountCode = (cart?.discount_codes || []).find(
      (item) => normalizeCode(item?.code) === target
    );
    if (discountCode) return discountCode.applicable !== false;
    return (cart?.cart_level_discount_applications || []).some(
      (item) => normalizeCode(item?.title) === target
    );
  }

  function emptyMemberMetadata() {
    return { version: 1, points: null, activity: null };
  }

  function parseMemberMetadata(cart) {
    const raw = cart?.attributes?.[MEMBER_REWARDS_ATTRIBUTE];
    if (!raw) return emptyMemberMetadata();
    try {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      const savedPoints = parsed?.points || parsed?.p;
      const savedActivity = parsed?.activity || parsed?.c;
      return {
        version: 1,
        points:
          savedPoints?.discount_code || savedPoints?.c
            ? {
              redeem_type: String(
                savedPoints.redeem_type ?? savedPoints.r ?? ''
              ),
              points: Number(savedPoints.points ?? savedPoints.p ?? 0),
              discount_amount: Number(
                savedPoints.discount_amount ?? savedPoints.a ?? 0
              ),
              label:
                savedPoints.label ||
                `$${Number(savedPoints.discount_amount ?? savedPoints.a ?? 0)} OFF / ${Number(savedPoints.points ?? savedPoints.p ?? 0)} Points`,
              discount_code: savedPoints.discount_code || savedPoints.c || ''
            }
            : null,
        activity:
          savedActivity?.discount_code || savedActivity?.c
            ? {
              key: savedActivity.key || savedActivity.k || '',
              id: String(savedActivity.id ?? savedActivity.i ?? ''),
              discount_code_type: Number(
                savedActivity.discount_code_type ?? savedActivity.t ?? 0
              ),
              shipping_month: Number(
                savedActivity.shipping_month ?? savedActivity.m ?? 0
              ),
              title:
                savedActivity.title || savedActivity.n || 'Member Coupon',
              detail: savedActivity.detail || '',
              discount_code:
                savedActivity.discount_code || savedActivity.c || ''
            }
            : null
      };
    } catch (error) {
      return emptyMemberMetadata();
    }
  }

  function sanitizeMemberMetadata(metadata, cart) {
    return {
      version: 1,
      points:
        metadata.points && isCodeApplicable(cart, metadata.points.discount_code)
          ? metadata.points
          : null,
      activity:
        metadata.activity &&
          isCodeApplicable(cart, metadata.activity.discount_code)
          ? metadata.activity
          : null
    };
  }

  function hasMemberRewards(selection) {
    return Boolean(selection?.points || selection?.activity);
  }

  function memberMetadataChanged(left, right) {
    return (
      JSON.stringify(left || emptyMemberMetadata()) !==
      JSON.stringify(right || emptyMemberMetadata())
    );
  }

  function getPointReward(redeemType, fallback) {
    const reward = MEMBER_REWARD_OPTIONS.find(
      (item) => item.redeemType === String(redeemType || '')
    );
    if (reward) return reward;
    if (!fallback) return null;
    return {
      redeemType: String(fallback.redeem_type || ''),
      points: Number(fallback.points || 0),
      amount: Number(fallback.discount_amount || 0),
      label:
        fallback.label ||
        `$${Number(fallback.discount_amount || 0)} OFF / ${Number(fallback.points || 0)} Points`
    };
  }

  function metadataToSelection(metadata) {
    const pointReward = metadata.points
      ? getPointReward(metadata.points.redeem_type, metadata.points)
      : null;
    const activityCoupon = metadata.activity
      ? memberRewardsState.coupons.find(
        (coupon) =>
          coupon.key === metadata.activity.key ||
          normalizeCode(coupon.code) ===
          normalizeCode(metadata.activity.discount_code)
      ) || {
        key:
          metadata.activity.key ||
          `saved-${metadata.activity.id || metadata.activity.discount_code}`,
        id: String(metadata.activity.id || ''),
        type: Number(metadata.activity.discount_code_type || 0),
        shippingMonth: Number(metadata.activity.shipping_month || 0),
        code: metadata.activity.discount_code,
        title: metadata.activity.title || 'Coupon',
        activityName: metadata.activity.title || 'Coupon',
        detail: metadata.activity.detail || ''
      }
      : null;
    return { points: pointReward, activity: activityCoupon };
  }

  async function fetchMemberCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json();
    window.mibaoCartData = cart;
    return cart;
  }

  function getPrizePayload(response) {
    return response?.data || response || {};
  }

  function formatPrizeDate(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).format(date);
  }

  function getShippingCouponUsage(coupon, now = new Date()) {
    if (coupon.type !== 4) return { available: true };
    const month = Number(coupon.shippingMonth);
    if (!Object.values(MEMBER_SHIPPING_COUPON_MONTHS).includes(month)) {
      return {
        available: false,
        description: 'Usage month unavailable'
      };
    }
    const monthLabel = new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      month: 'long',
      year: 'numeric'
    }).format(new Date(Date.UTC(MEMBER_SHIPPING_COUPON_YEAR, month - 1, 1)));
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: 'numeric'
    }).formatToParts(now);
    const currentYear = Number(parts.find((part) => part.type === 'year').value);
    const currentMonth = Number(parts.find((part) => part.type === 'month').value);
    const available =
      currentYear === MEMBER_SHIPPING_COUPON_YEAR && currentMonth === month;
    const expired =
      currentYear > MEMBER_SHIPPING_COUPON_YEAR ||
      (currentYear === MEMBER_SHIPPING_COUPON_YEAR && currentMonth > month);
    return {
      available,
      monthLabel: `${monthLabel} · PT`,
      description: available
        ? 'Valid this month (PT)'
        : expired
          ? `Expired · ${monthLabel} (PT)`
          : `Available in ${monthLabel} (PT)`
    };
  }

  function normalizeActivityCoupon(record, index) {
    const code = String(record?.shopify_discount_code || '').trim();
    if (!code) return null;
    const type = Number(record.discount_code_type || 0);
    let title =
      record.activity_name ||
      record.activity_title ||
      record.prize_name ||
      record.title ||
      '';
    let valueTitle = title;
    let valueSubtitle = '';
    let detail = record.description || '';
    if (type === 4) {
      title = title || 'FREE SHIPPING';
      valueTitle = 'FREE';
      valueSubtitle = 'SHIPPING';
      detail = detail || 'Free shipping reward';
    } else if (type === 5) {
      title = title || `$${Number(record.n || 0)} OFF`;
      valueTitle = `$${Number(record.n || 0)} OFF`;
      detail = detail || `On orders over $${Number(record.m || 0)}`;
    } else if (type === 6) {
      title =
        title || `BUY ${Number(record.m || 0)} GET ${Number(record.n || 0)}`;
      valueTitle = `BUY ${Number(record.m || 0)}`;
      valueSubtitle = `GET ${Number(record.n || 0)}`;
      detail = detail || 'Buy and get reward';
    } else {
      title = title || 'MEMBER COUPON';
      valueTitle = title;
      detail = detail || 'Member reward';
    }
    const id = String(record.id ?? `coupon-${index}`);
    return {
      key: `${id}:${code}`,
      id,
      type,
      shippingMonth:
        type === 4
          ? MEMBER_SHIPPING_COUPON_MONTHS[Number(record.free_shipping_type)] || 0
          : 0,
      code,
      title,
      activityName: title,
      valueTitle,
      valueSubtitle,
      detail,
      validUntil: formatPrizeDate(
        record.valid_until ||
        record.expire_time ||
        record.expiration_time ||
        record.ends_time
      )
    };
  }

  async function fetchActivityCoupons(email) {
    const pageSize = 1000;
    const coupons = [];
    let currentPage = 1;
    let totalPage = 1;
    do {
      const response = await window.ogl_fetch.get(
        '/api/v1/activity/get-prize-list-paging',
        {
          current_page: currentPage,
          page_size: pageSize,
          email
        }
      );
      const payload = getPrizePayload(response);
      const list = Array.isArray(payload.total_list) ? payload.total_list : [];
      list.forEach((record, index) => {
        const coupon = normalizeActivityCoupon(record, coupons.length + index);
        if (coupon) coupons.push(coupon);
      });
      totalPage = Math.max(1, Number(payload.total_page || 1));
      currentPage += 1;
    } while (currentPage <= totalPage && currentPage <= 100);
    const seenCodes = new Set();
    return coupons.filter((coupon) => {
      const code = normalizeCode(coupon.code);
      if (seenCodes.has(code)) return false;
      seenCodes.add(code);
      return true;
    });
  }

  function serializeMemberMetadata(metadata) {
    if (!hasMemberRewards(metadata)) return '';
    return JSON.stringify({
      v: 1,
      p: metadata.points
        ? {
          r: String(metadata.points.redeem_type || ''),
          p: Number(metadata.points.points || 0),
          a: Number(metadata.points.discount_amount || 0),
          c: metadata.points.discount_code
        }
        : null,
      c: metadata.activity
        ? {
          k: metadata.activity.key || '',
          i: String(metadata.activity.id || ''),
          t: Number(metadata.activity.discount_code_type || 0),
          m: Number(metadata.activity.shipping_month || 0),
          n: metadata.activity.title || 'Member Coupon',
          c: metadata.activity.discount_code
        }
        : null
    });
  }

  async function updateMemberCart(discountCodes, metadata) {
    const response = await fetch(
      window.Shopify.routes.root + 'cart/update.js',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: uniqueCodes(discountCodes).join(','),
          attributes: {
            [MEMBER_REWARDS_ATTRIBUTE]: serializeMemberMetadata(metadata)
          }
        })
      }
    );
    if (!response.ok) throw new Error('Unable to update cart rewards');
    const cart = await response.json();
    window.mibaoCartData = cart;
    return cart;
  }

  function createChip(label, kind, removable) {
    const chip = document.createElement('span');
    chip.className = 'member-rewards-chip';
    const icon = document.createElement('span');
    icon.setAttribute('aria-hidden', 'true');
    icon.className = "member-rewards-chip_icon"
    icon.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_7352_13)">
		<path d="M7.525 13.125L0.875 7.175V0.875H6.825L13.125 7.175L7.525 13.125ZM6.475 1.575H1.575V6.825L7.525 12.075L12.075 7.175L6.475 1.575Z" fill="currentColor"></path>
		<path
			d="M5.40374 5.22894C5.30629 5.32649 5.19057 5.40388 5.06319 5.45668C4.93582 5.50948 4.79928 5.53666 4.66139 5.53666C4.52351 5.53666 4.38697 5.50948 4.25959 5.45668C4.13222 5.40388 4.01649 5.32649 3.91904 5.22894C3.82149 5.13149 3.7441 5.01577 3.6913 4.88839C3.6385 4.76101 3.61133 4.62448 3.61133 4.48659C3.61133 4.3487 3.6385 4.21217 3.6913 4.08479C3.7441 3.95741 3.82149 3.84169 3.91904 3.74424C4.01649 3.64669 4.13222 3.5693 4.25959 3.5165C4.38697 3.4637 4.52351 3.43652 4.66139 3.43652C4.79928 3.43652 4.93582 3.4637 5.06319 3.5165C5.19057 3.5693 5.30629 3.64669 5.40374 3.74424C5.50129 3.84169 5.57868 3.95741 5.63148 4.08479C5.68428 4.21217 5.71146 4.3487 5.71146 4.48659C5.71146 4.62448 5.68428 4.76101 5.63148 4.88839C5.57868 5.01577 5.50129 5.13149 5.40374 5.22894ZM4.41394 4.23914C4.34832 4.30477 4.31145 4.39378 4.31145 4.48659C4.31145 4.5794 4.34832 4.66841 4.41394 4.73404C4.47957 4.79967 4.56858 4.83654 4.66139 4.83654C4.75421 4.83654 4.84322 4.79967 4.90884 4.73404C4.97447 4.66841 5.01134 4.5794 5.01134 4.48659C5.01134 4.39378 4.97447 4.30477 4.90884 4.23914C4.84322 4.17351 4.75421 4.13664 4.66139 4.13664C4.56858 4.13664 4.47957 4.17351 4.41394 4.23914Z"
			fill="currentColor"></path>
	</g>
	<defs>
		<clipPath id="clip0_7352_13">
			<rect width="14" height="14" fill="none"></rect>
		</clipPath>
	</defs>
</svg>`;
    const text = document.createElement('span');
    text.className = 'member-rewards-chip__text';
    text.textContent = label;
    chip.append(icon, text);
    if (removable) {
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'member-rewards-chip__remove';
      remove.dataset.memberRemoveSelection = kind;
      remove.setAttribute('aria-label', `Remove ${label}`);
      remove.textContent = '×';
      chip.append(remove);
    }
    return chip;
  }

  function renderSelectionChips(container, selection, removable) {
    if (!container) return;
    container.replaceChildren();
    if (selection.points) {
      container.append(createChip(selection.points.label, 'points', removable));
    }
    if (selection.activity) {
      container.append(
        createChip(
          selection.activity.activityName || selection.activity.title,
          'activity',
          removable
        )
      );
    }
  }

  function createActivityCard(coupon, selected) {
    const usage = getShippingCouponUsage(coupon);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `member-reward-card${selected ? ' is-selected' : ''}`;
    button.dataset.activityReward = coupon.key;
    button.setAttribute('aria-pressed', String(selected));
    button.disabled = !usage.available;
    button.classList.toggle('is-disabled', !usage.available);
    button.setAttribute('aria-disabled', String(!usage.available));

    const value = document.createElement('span');
    value.className = 'member-reward-card__value';
    const badge = document.createElement('span');
    badge.className = 'member-reward-card__badge';
    badge.textContent = coupon.type === 4 ? 'Free Shipping' : 'Discounts & Gifts';
    const name = document.createElement('span');
    name.className = 'member-reward-card__name';
    name.textContent = coupon.activityName;
    const title = document.createElement('strong');
    title.className = 'member-reward-card__title';
    title.textContent = [coupon.valueTitle, coupon.valueSubtitle]
      .filter(Boolean)
      .join(' ');
    value.append(badge, name, title);
    if (usage.monthLabel) {
      const month = document.createElement('span');
      month.className = 'member-reward-card__name';
      month.textContent = usage.monthLabel;
      value.insertBefore(month, title);
    }
    const description = usage.description || coupon.detail;
    if (description) {
      const subtitle = document.createElement('span');
      subtitle.className = 'member-reward-card__subtitle';
      subtitle.textContent = description;
      value.append(subtitle);
    }
    if (coupon.validUntil) {
      const meta = document.createElement('span');
      meta.className = 'member-reward-card__meta';
      meta.textContent = `Valid until ${coupon.validUntil}`;
      value.append(meta);
    }

    const control = document.createElement('span');
    control.className = 'member-reward-card__control';
    const check = document.createElement('span');
    check.className = 'member-reward-card__check';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';
    control.append(check);
    button.append(value, control);
    return button;
  }

  function renderActivityGroup(root, selector, emptySelector, coupons, emptyMessage) {
    const list = root.querySelector(selector);
    const empty = root.querySelector(emptySelector);
    if (!list || !empty) return;
    list.replaceChildren();
    coupons.forEach((coupon) => {
      list.append(
        createActivityCard(
          coupon,
          memberRewardsState.draft.activity?.key === coupon.key
        )
      );
    });
    empty.hidden = coupons.length > 0;
    empty.textContent = memberRewardsState.couponsLoaded
      ? emptyMessage
      : 'Loading coupons…';
  }

  function hideManagedDiscountRows(root) {
    const managedCodes = [
      memberRewardsState.applied.points?.discount_code,
      memberRewardsState.applied.activity?.discount_code
    ].map(normalizeCode);
    const cartWrapper = root.closest('[data-cart-wrapper]');
    cartWrapper
      ?.querySelectorAll('[data-cart-discount-code]')
      .forEach((row) => {
        row.hidden = managedCodes.includes(
          normalizeCode(row.dataset.cartDiscountCode)
        );
      });
  }

  function renderMemberRewardRoot(root) {
    root.querySelector('[data-member-points]').textContent = String(
      memberRewardsState.points
    );
    root.querySelector('[data-member-coupon-count]').textContent = String(
      memberRewardsState.coupons.length
    );

    const hasApplied = hasMemberRewards(memberRewardsState.applied);
    const bannerLabel = root.querySelector('[data-member-banner-label]');
    bannerLabel.textContent = hasApplied
      ? "You've chosen"
      : 'Choose to apply points & coupons';
    renderSelectionChips(
      root.querySelector('[data-member-banner-chips]'),
      memberRewardsState.applied,
      false
    );

    const refundablePoints = Number(
      memberRewardsState.applied.points?.points || 0
    );
    const availableForSelection = memberRewardsState.points + refundablePoints;
    root.querySelectorAll('[data-points-reward]').forEach((card) => {
      const redeemType = card.dataset.redeemType;
      const selected =
        memberRewardsState.draft.points?.redeemType === redeemType;
      const disabled =
        Number(card.dataset.points) > availableForSelection && !selected;
      card.classList.toggle('is-selected', selected);
      card.classList.toggle('is-disabled', disabled);
      card.setAttribute('aria-pressed', String(selected));
      card.setAttribute('aria-disabled', String(disabled));
    });

    renderActivityGroup(
      root,
      '[data-activity-shipping-list]',
      '[data-activity-shipping-empty]',
      memberRewardsState.coupons
        .filter((coupon) => coupon.type === 4)
        .sort(
          (left, right) =>
            (left.shippingMonth || 99) - (right.shippingMonth || 99)
        ),
      'No free shipping coupons available.'
    );
    renderActivityGroup(
      root,
      '[data-activity-offer-list]',
      '[data-activity-offer-empty]',
      memberRewardsState.coupons.filter((coupon) => coupon.type !== 4),
      'No discount or gift coupons available.'
    );

    const hasDraft = hasMemberRewards(memberRewardsState.draft);
    const selectionBox = root.querySelector('[data-member-footer-selection]');
    const emptyApply = root.querySelector('[data-member-rewards-apply-empty]');
    const closeOnly = root.querySelector('[data-member-rewards-close-empty]');
    selectionBox.hidden = !hasDraft;
    emptyApply.hidden = hasDraft || !hasApplied;
    closeOnly.hidden = hasDraft || hasApplied;
    renderSelectionChips(
      root.querySelector('[data-member-footer-chips]'),
      memberRewardsState.draft,
      true
    );

    root
      .querySelectorAll(
        '[data-member-rewards-apply], [data-member-rewards-apply-empty]'
      )
      .forEach((button) => {
        button.disabled = memberRewardsState.loading;
        button.classList.toggle('is-loading', memberRewardsState.loading);
      });
    hideManagedDiscountRows(root);
  }

  function renderMemberRewards() {
    getMemberRewardRoots().forEach(renderMemberRewardRoot);
  }

  function switchMemberRewardsTab(root, tabName) {
    root.querySelectorAll('[data-member-rewards-tab]').forEach((tab) => {
      tab.setAttribute(
        'aria-selected',
        String(tab.dataset.memberRewardsTab === tabName)
      );
    });
    root.querySelectorAll('[data-member-rewards-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.memberRewardsPanel !== tabName;
    });
  }

  const memberRewardsTransitions = new WeakMap();

  function resetMemberRewardsTransition(overlay) {
    const previous = memberRewardsTransitions.get(overlay);
    if (previous) {
      window.cancelAnimationFrame(previous.frame);
      window.clearTimeout(previous.timer);
    }
    const transition = { frame: 0, timer: 0 };
    memberRewardsTransitions.set(overlay, transition);
    return transition;
  }

  function openMemberRewards(root) {
    const overlay = root.querySelector('[data-member-rewards-overlay]');
    const transition = resetMemberRewardsTransition(overlay);
    memberRewardsState.draft = metadataToSelection(memberRewardsState.applied);
    renderMemberRewards();
    switchMemberRewardsTab(root, 'points');

    // Prepare the stacking context before mounting the drawer for its animation.
    root
      .closest('[data-cart-wrapper]')
      ?.classList.add('member-rewards-is-open');
    root
      .querySelector('[data-member-rewards-open]')
      ?.setAttribute('aria-expanded', 'true');
    overlay.classList.remove('is-closing');
    transition.frame = window.requestAnimationFrame(() => {
      if (!root.isConnected) return;
      overlay.hidden = false;
      transition.frame = window.requestAnimationFrame(() => {
        overlay.classList.add('is-visible');
        root
          .querySelector('.member-rewards-sheet__close')
          ?.focus({ preventScroll: true });
      });
    });
  }

  function closeMemberRewards(root) {
    memberRewardsState.draft = metadataToSelection(memberRewardsState.applied);
    const overlay = root.querySelector('[data-member-rewards-overlay]');
    const cartWrapper = root.closest('[data-cart-wrapper]');
    const transition = resetMemberRewardsTransition(overlay);
    const wasVisible = overlay.classList.contains('is-visible');
    overlay.classList.add('is-closing');
    overlay.classList.remove('is-visible');
    root
      .querySelector('[data-member-rewards-open]')
      ?.setAttribute('aria-expanded', 'false');

    const finishClosing = () => {
      overlay.hidden = true;
      overlay.classList.remove('is-closing');
      if (!cartWrapper?.querySelector('.member-rewards-overlay.is-visible')) {
        cartWrapper?.classList.remove('member-rewards-is-open');
      }
      if (root.isConnected) {
        root
          .querySelector('[data-member-rewards-open]')
          ?.focus({ preventScroll: true });
      }
    };
    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    if (wasVisible && !reducedMotion) {
      transition.timer = window.setTimeout(finishClosing, 260);
    } else {
      finishClosing();
    }
    renderMemberRewards();
  }

  function getRedeemedDiscountCode(response) {
    return String(
      response?.data?.[0]?.discount_code ||
      response?.data?.discount_code ||
      response?.discount_code ||
      ''
    ).trim();
  }

  function publishRewardsEvent(name, payload = {}) {
    Shopify.analytics.publish('member-datac', {
      customerId: window.customer_id || '',
      platform: window.innerWidth > 768 ? 'pc' : 'mobile',
      name,
      ...payload
    });
  }

  async function refreshThemeCart() {
    if (window.T4SThemeSP?.Cart?.getToFetch) {
      await T4SThemeSP.Cart.getToFetch();
    }
  }

  let guestMemberRewardsCleanupPromise = null;

  function clearGuestMemberRewards() {
    if (window.customer?.id) return Promise.resolve();
    if (guestMemberRewardsCleanupPromise) {
      return guestMemberRewardsCleanupPromise;
    }
    guestMemberRewardsCleanupPromise = (async () => {
      // Finish any previous member initialization before clearing its cart state.
      if (memberRewardsState.initPromise) {
        await memberRewardsState.initPromise;
      }
      if (window.customer?.id) return;
      const cleanup = window.oglGuestMemberRewards;
      if (!cleanup) return;
      const updatedCart = await cleanup.clear();
      if (!updatedCart) return;
      const emptyMetadata = emptyMemberMetadata();
      memberRewardsState.cart = updatedCart;
      memberRewardsState.applied = emptyMetadata;
      memberRewardsState.draft = metadataToSelection(emptyMetadata);
      memberRewardsState.points = 0;
      memberRewardsState.coupons = [];
      memberRewardsState.couponsLoaded = false;

      // Refresh the rendered totals only after Shopify has removed the codes.
      await refreshThemeCart();
      cleanup.acknowledge(updatedCart);
    })()
      .catch((error) => {
        window.oglToast?.show({
          message: 'Unable to clear member rewards. Please try again.'
        });
        window.report_faro?.({
          file_name: 'assets/init-event.js',
          func_name: 'clearGuestMemberRewards',
          desc: 'Failed to clear member rewards after logout',
          error
        });
      })
      .finally(() => {
        guestMemberRewardsCleanupPromise = null;
      });
    return guestMemberRewardsCleanupPromise;
  }

  async function applyMemberRewards(root) {
    if (memberRewardsState.loading) return;
    memberRewardsState.loading = true;
    renderMemberRewards();
    let generatedPointCode = '';
    let oldPointWasRecalled = false;
    try {
      const cart = await fetchMemberCart();
      const persistedMetadata = parseMemberMetadata(cart);
      const savedMetadata = sanitizeMemberMetadata(persistedMetadata, cart);
      const selectedPoint = memberRewardsState.draft.points;
      const selectedActivity = memberRewardsState.draft.activity;
      const activityUsage = selectedActivity
        ? getShippingCouponUsage(selectedActivity)
        : null;
      if (activityUsage && !activityUsage.available) {
        window.oglToast.show({ message: activityUsage.description });
        return;
      }
      const pointChanged =
        String(savedMetadata.points?.redeem_type || '') !==
        String(selectedPoint?.redeemType || '');

      if (pointChanged && persistedMetadata.points?.discount_code) {
        await recallCoupon(persistedMetadata.points.discount_code);
        oldPointWasRecalled = true;
      }

      let nextPointMetadata = null;
      if (selectedPoint) {
        if (!pointChanged && savedMetadata.points?.discount_code) {
          nextPointMetadata = savedMetadata.points;
        } else {
          const redeemed = await redeemCoupon(selectedPoint.redeemType);
          generatedPointCode = getRedeemedDiscountCode(redeemed);
          if (!generatedPointCode)
            throw new Error('No points discount code returned');
          nextPointMetadata = {
            redeem_type: selectedPoint.redeemType,
            points: selectedPoint.points,
            discount_amount: selectedPoint.amount,
            label: selectedPoint.label,
            discount_code: generatedPointCode
          };
        }
      }

      const nextActivityMetadata = selectedActivity
        ? {
          key: selectedActivity.key,
          id: selectedActivity.id,
          discount_code_type: selectedActivity.type,
          shipping_month: selectedActivity.shippingMonth || 0,
          title: selectedActivity.activityName || selectedActivity.title,
          detail: selectedActivity.detail || '',
          discount_code: selectedActivity.code
        }
        : null;
      let nextMetadata = {
        version: 1,
        points: nextPointMetadata,
        activity: nextActivityMetadata
      };

      const oldManagedCodes = [
        persistedMetadata.points?.discount_code,
        persistedMetadata.activity?.discount_code
      ].map(normalizeCode);
      const retainedCodes = getCartDiscountCodes(cart).filter(
        (code) => !oldManagedCodes.includes(normalizeCode(code))
      );
      let desiredCodes = uniqueCodes([
        ...retainedCodes,
        nextPointMetadata?.discount_code,
        nextActivityMetadata?.discount_code
      ]);
      let updatedCart = await updateMemberCart(desiredCodes, nextMetadata);

      let needsCorrection = false;
      if (
        nextPointMetadata &&
        !isCodeApplicable(updatedCart, nextPointMetadata.discount_code)
      ) {
        if (generatedPointCode) await recallCoupon(generatedPointCode);
        desiredCodes = desiredCodes.filter(
          (code) =>
            normalizeCode(code) !==
            normalizeCode(nextPointMetadata.discount_code)
        );
        nextMetadata.points = null;
        generatedPointCode = '';
        needsCorrection = true;
        window.oglToast.show({
          message: `Sorry, Points couldn't be applied to your cart.`
        });
      }
      if (
        nextActivityMetadata &&
        !isCodeApplicable(updatedCart, nextActivityMetadata.discount_code)
      ) {
        desiredCodes = desiredCodes.filter(
          (code) =>
            normalizeCode(code) !==
            normalizeCode(nextActivityMetadata.discount_code)
        );
        nextMetadata.activity = null;
        needsCorrection = true;
        window.oglToast.show({
          message: 'This coupon could not be applied to your cart.'
        });
      }
      if (needsCorrection) {
        updatedCart = await updateMemberCart(desiredCodes, nextMetadata);
      }

      memberRewardsState.cart = updatedCart;
      memberRewardsState.applied = sanitizeMemberMetadata(
        nextMetadata,
        updatedCart
      );
      memberRewardsState.draft = metadataToSelection(
        memberRewardsState.applied
      );
      try {
        const customer = await fetchUserPoints();
        memberRewardsState.points = Number(customer.total_points || 0);
      } catch (pointsError) { }
      publishRewardsEvent('cart_member_rewards_apply', {
        point_value: memberRewardsState.applied.points?.points || 0,
        activity_coupon: memberRewardsState.applied.activity?.title || ''
      });
      closeMemberRewards(root);
      try {
        await refreshThemeCart();
      } catch (refreshError) { }
    } catch (error) {
      if (generatedPointCode) {
        try {
          await recallCoupon(generatedPointCode);
        } catch (recallError) { }
      }
      if (oldPointWasRecalled) {
        try {
          const currentCart = await fetchMemberCart();
          const staleMetadata = parseMemberMetadata(currentCart);
          const oldCode = staleMetadata.points?.discount_code;
          staleMetadata.points = null;
          const remainingCodes = getCartDiscountCodes(currentCart).filter(
            (code) => normalizeCode(code) !== normalizeCode(oldCode)
          );
          memberRewardsState.cart = await updateMemberCart(
            remainingCodes,
            staleMetadata
          );
          memberRewardsState.applied = sanitizeMemberMetadata(
            staleMetadata,
            memberRewardsState.cart
          );
        } catch (cleanupError) { }
      }
      try {
        const customer = await fetchUserPoints();
        memberRewardsState.points = Number(customer.total_points || 0);
      } catch (pointsError) { }
      window.oglToast.show({
        message: 'Unable to update rewards. Please try again.'
      });
      window.report_faro?.({
        file_name: 'assets/init-event.js',
        func_name: 'applyMemberRewards',
        desc: 'Failed to update member cart rewards',
        error
      });
    } finally {
      memberRewardsState.loading = false;
      renderMemberRewards();
    }
  }

  function handleMemberRewardsClick(event) {
    const root = event.currentTarget;
    const target = event.target;
    if (target.closest('[data-member-rewards-help]')) {
      event.preventDefault();
      window.memberPolicyClick?.();
      return;
    }
    if (target.closest('[data-member-rewards-open]')) {
      openMemberRewards(root);
      return;
    }
    if (
      target.closest(
        '[data-member-rewards-close], [data-member-rewards-close-empty]'
      )
    ) {
      closeMemberRewards(root);
      return;
    }
    const tab = target.closest('[data-member-rewards-tab]');
    if (tab) {
      switchMemberRewardsTab(root, tab.dataset.memberRewardsTab);
      return;
    }
    const pointsCard = target.closest('[data-points-reward]');
    if (pointsCard) {
      if (pointsCard.getAttribute('aria-disabled') === 'true') return;
      const reward = getPointReward(pointsCard.dataset.redeemType);
      memberRewardsState.draft.points =
        memberRewardsState.draft.points?.redeemType === reward.redeemType
          ? null
          : reward;
      publishRewardsEvent('cart_discount_select_option', {
        point_value: reward.points
      });
      renderMemberRewards();
      return;
    }
    const activityCard = target.closest('[data-activity-reward]');
    if (activityCard) {
      const coupon = memberRewardsState.coupons.find(
        (item) => item.key === activityCard.dataset.activityReward
      );
      if (!coupon || !getShippingCouponUsage(coupon).available) return;
      memberRewardsState.draft.activity =
        memberRewardsState.draft.activity?.key === coupon.key ? null : coupon;
      renderMemberRewards();
      return;
    }
    const removeSelection = target.closest('[data-member-remove-selection]');
    if (removeSelection) {
      memberRewardsState.draft[removeSelection.dataset.memberRemoveSelection] =
        null;
      renderMemberRewards();
      return;
    }
    if (
      target.closest(
        '[data-member-rewards-apply], [data-member-rewards-apply-empty]'
      )
    ) {
      void applyMemberRewards(root);
    }
  }

  function bindMemberRewardRoots() {
    getMemberRewardRoots().forEach((root) => {
      if (root.dataset.memberRewardsBound === 'true') return;
      root.dataset.memberRewardsBound = 'true';
      root.addEventListener('click', handleMemberRewardsClick);
    });
  }

  async function initMemberRewards() {
    const roots = getMemberRewardRoots();
    if (!roots.length || !window.customer?.id) return;
    bindMemberRewardRoots();
    renderMemberRewards();
    if (memberRewardsState.initPromise) return memberRewardsState.initPromise;
    memberRewardsState.initPromise = (async () => {
      const email = roots[0].dataset.customerEmail || window.customer.email;
      const [pointsResult, couponsResult, cartResult] =
        await Promise.allSettled([
          fetchUserPoints(),
          fetchActivityCoupons(email),
          fetchMemberCart()
        ]);
      if (pointsResult.status === 'fulfilled') {
        memberRewardsState.points = Number(
          pointsResult.value.total_points || 0
        );
      }
      if (couponsResult.status === 'fulfilled') {
        memberRewardsState.coupons = couponsResult.value;
      } else {
        memberRewardsState.coupons = [];
      }
      memberRewardsState.couponsLoaded = true;
      if (cartResult.status === 'fulfilled') {
        memberRewardsState.cart = cartResult.value;
        const parsedMetadata = parseMemberMetadata(cartResult.value);
        const cleanMetadata = sanitizeMemberMetadata(
          parsedMetadata,
          cartResult.value
        );
        memberRewardsState.applied = cleanMetadata;
        memberRewardsState.draft = metadataToSelection(cleanMetadata);
        if (memberMetadataChanged(parsedMetadata, cleanMetadata)) {
          if (parsedMetadata.points?.discount_code && !cleanMetadata.points) {
            try {
              await recallCoupon(parsedMetadata.points.discount_code);
              const customer = await fetchUserPoints();
              memberRewardsState.points = Number(customer.total_points || 0);
            } catch (recallError) { }
          }
          const staleCodes = [
            parsedMetadata.points?.discount_code,
            parsedMetadata.activity?.discount_code
          ]
            .filter((code) => {
              if (!code) return false;
              return ![
                cleanMetadata.points?.discount_code,
                cleanMetadata.activity?.discount_code
              ].some(
                (cleanCode) => normalizeCode(cleanCode) === normalizeCode(code)
              );
            })
            .map(normalizeCode);
          const retainedCodes = getCartDiscountCodes(cartResult.value).filter(
            (code) => !staleCodes.includes(normalizeCode(code))
          );
          const cleanedCart = await updateMemberCart(
            retainedCodes,
            cleanMetadata
          );
          memberRewardsState.cart = cleanedCart;
        }
      }
      renderMemberRewards();
    })()
      .catch((error) => {
        window.report_faro?.({
          file_name: 'assets/init-event.js',
          func_name: 'initMemberRewards',
          desc: 'Failed to initialize member cart rewards',
          error
        });
      })
      .finally(() => {
        memberRewardsState.initPromise = null;
      });
    return memberRewardsState.initPromise;
  }

  window.handleRemoveCoupon = async function handleRemoveCoupon(currentCode) {
    if (!currentCode) return;
    try {
      window.oglLoading(true);
      const cart = await fetchMemberCart();
      const metadata = sanitizeMemberMetadata(parseMemberMetadata(cart), cart);
      if (
        normalizeCode(metadata.points?.discount_code) ===
        normalizeCode(currentCode)
      ) {
        await recallCoupon(metadata.points.discount_code);
        metadata.points = null;
      }
      if (
        normalizeCode(metadata.activity?.discount_code) ===
        normalizeCode(currentCode)
      ) {
        metadata.activity = null;
      }
      const remainingCodes = getCartDiscountCodes(cart).filter(
        (code) => normalizeCode(code) !== normalizeCode(currentCode)
      );
      memberRewardsState.cart = await updateMemberCart(
        remainingCodes,
        metadata
      );
      memberRewardsState.applied = sanitizeMemberMetadata(
        metadata,
        memberRewardsState.cart
      );
      memberRewardsState.draft = metadataToSelection(
        memberRewardsState.applied
      );
      publishRewardsEvent('remove_coupon', { discount_code: currentCode });
      await refreshThemeCart();
    } catch (error) {
      window.oglToast.show({ message: 'Remove Coupon Fail!' });
    } finally {
      window.oglLoading(false);
    }
  };

  let couponApplyLoading = false

  function publishMemberDatac(payload) {
    Shopify.analytics.publish("member-datac", {
      customerId: window.customer_id || "",
      platform: !window.innerWidth < 768 ? "pc" : "mobile",
      ...payload,
    });
  }

  function handleCouponDocumentClick() {
    const selectItems = document.getElementById('select-items');
    const selectSelected = document.getElementById('select-selected');
    if (!selectItems || !selectSelected) {
      return
    }
    selectItems.style.display = 'none';
    selectSelected.classList.remove('select-active');
  }

  async function handleApplyCouponAction(btn_dom) {
    if (couponApplyLoading || !btn_dom) {
      return
    }
    const spinner = btn_dom.querySelector('.t4s-loading__spinner')
    const btn_text = btn_dom.querySelector('.t4s-btn-atc_text')
    const couponSelector = document.querySelector('.coupon-selector_wrapper .coupon-selector');
    couponApplyLoading = true
    try {
      const hiddenInput = document.getElementById('CartDiscountcode');
      const selectedCouponCode = hiddenInput.value;
      if (!selectedCouponCode) {
        return
      }
      couponSelector?.classList.add('is-loading')
      btn_dom.classList.add('is-loading')
      spinner.style.display = 'block'
      btn_text.style.display = 'none'
      const applySuccess = await applyCoupon(selectedCouponCode);
      if (applySuccess) {
        Shopify.analytics.publish("member-datac", {
          customerId: window.customer_id || "",
          platform: !window.innerWidth < 768 ? "pc" : "mobile",
          name: 'cart_discount_code_apply',
        });
      }
    } catch (err) {
      window.report_faro({
        file_name: 'assets/init-event.js',
        func_name: 'handleApplyCouponAction',
        desc: 'Failed to apply the coupon code',
        error: err
      });
    } finally {
      couponApplyLoading = false
      couponSelector?.classList.remove('is-loading')
      btn_dom.classList.remove('is-loading')
      spinner.style.display = 'none'
      btn_text.style.display = 'block'
    }
  }

  // 点击 Apply 按钮只负责打开/关闭下拉
  function handleApplyBtnEvent(coupon_code) {
    const applyBtn = document.querySelector(
      '.coupon-selector_wrapper #coupon-apply'
    );
    const selectSelected = document.getElementById('select-selected');
    if (!applyBtn || !selectSelected) {
      return
    }
    applyBtn.onclick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      selectSelected.click();
    };
  }

  // 下拉选项用券初始化
  var selectSelected = null

  function retryInitCoupon(e) {
    selectSelected = document.getElementById('select-selected');
    e.stopPropagation();
    initCouponSelect()
  }

  async function initCouponSelect() {
    selectSelected = document.getElementById('select-selected');
    //如果没有select-selected，那么就是不是下拉选项用券的逻辑
    if (!selectSelected) {
      return
    }
    const selectItems = document.getElementById('select-items');
    const options = document.querySelectorAll('.select-option');
    const hiddenInput = document.getElementById('CartDiscountcode');
    const applyBtn = document.querySelector(
      '.coupon-selector_wrapper #coupon-apply'
    );
    const load_res = await getPointsUpdateCouponEnable(options);
    if (!load_res) {
      // 加载失败，点击selected重置所有流程
      selectSelected.addEventListener('click', retryInitCoupon);
      return
    }

    selectSelected.removeEventListener('click', retryInitCoupon)

    // 点击选择框显示/隐藏选项
    selectSelected.onclick = function (e) {
      e.stopPropagation();
      const willOpen = selectItems.style.display !== 'block';
      if (willOpen) {
        closeAllSelect(this);
      }
      selectItems.style.display = willOpen ? 'block' : 'none';
      this.classList.toggle('select-active', willOpen);
      publishMemberDatac({
        name: 'cart_discount_select_click_' + (willOpen ? 'expand' : 'collapse'),
      });
    };

    // 点击选项
    options.forEach((option, index) => {
      option.onclick = async function () {
        const disabled = this.getAttribute('data-disabled');

        const points = this.getAttribute('data-points');
        publishMemberDatac({
          name: 'cart_discount_select_option',
          point_value: points,
        });

        if (disabled == 1) {
          return;
        }
        const value = this.getAttribute('data-value');
        const text = this.textContent;

        // 更新显示和隐藏输入值
        const selectValueBox = selectSelected.querySelector('.select-selected');
        selectValueBox.textContent = text;
        hiddenInput.value = value;

        // 移除所有选项的active类并添加当前选项的active类
        options.forEach((opt) => opt.classList.remove('select-option-active'));
        this.classList.add('select-option-active');

        // 关闭下拉框
        selectItems.style.display = 'none';
        selectSelected.classList.remove('select-active');
        await handleApplyCouponAction(applyBtn);
      };
    });

    // 点击页面其他地方关闭下拉框
    document.removeEventListener('click', handleCouponDocumentClick);
    document.addEventListener('click', handleCouponDocumentClick);

    // 关闭其他打开的下拉框
    function closeAllSelect(elmnt) {
      const selectItems = document.getElementsByClassName('select-items');
      const selectSelected = document.getElementsByClassName('select-selected');

      for (let i = 0; i < selectSelected.length; i++) {
        if (elmnt !== selectSelected[i] && elmnt !== selectItems[i]) {
          selectSelected[i].classList.remove('select-active');
        }
      }

      for (let i = 0; i < selectItems.length; i++) {
        if (elmnt !== selectItems[i]) {
          selectItems[i].style.display = 'none';
        }
      }
    }
  }

  window.memberPolicyClick = function memberPolicyClick() {
    document.querySelector('#rules-modal-href')?.click()
    publishMemberDatac({
      name: 'member-policy-click',
    });
  }

  function cartLoginBannerInit() {
    if (!window.customer?.id) {
      void clearGuestMemberRewards();
      return;
    }
    const pendingCleanup =
      guestMemberRewardsCleanupPromise || window.oglGuestMemberRewards?.pending;
    if (pendingCleanup) {
      void pendingCleanup.then(() => {
        if (window.customer?.id) cartLoginBannerInit();
      });
      return;
    }
    initMemberRewards();
    initCouponSelect();
    handleApplyBtnEvent();
  }

  function onLogined() {
    T4SThemeSP.MobileNav(false)
    window.customer && cartLoginBannerInit();
  }

  document.addEventListener('data-collection-open-drawer', function () {
    Shopify.analytics.publish("member-datac", {
      customerId: window.customer_id || "",
      platform: window.innerWidth > 768 ? "pc" : "mobile",
      name: 'mini_cart_open'
    });
  })

  $(window).on('cart:inited', function () {
    // onColorSwatchChange()
    cartLoginBannerInit();
  })

  $(window).on('cart:updated', function () {
    // onColorSwatchChange()
    cartLoginBannerInit();
  })

  // 购物车页面初始化
  if (meta.page.pageType == 'cart') {
    window.addEventListener("DOMContentLoaded", function () {
      cartLoginBannerInit();
      window.handleCartChange('.t4s-main-cart')
    })
  }

  document.addEventListener('logined', onLogined);

  if (window.customer?.id) {
    const loginEvent = new CustomEvent('logined');
    document.dispatchEvent(loginEvent)
  } else {
    cartLoginBannerInit();
  }
})();
